import { Component, PropSync, Vue, Watch } from "vue-property-decorator";

@Component<Pagination>({
  components: {}
})
export default class Pagination extends Vue {
  @PropSync("current", { type: Number })
  syncedCurrent!: number;
  @PropSync("total", { type: Number })
  syncedTotal!: number;
  @PropSync("limit", { type: Number })
  syncedLimit!: number;

  private block: {
    list: number[];
    section: number;
    min: number;
    max: number;
  } = {
    list: [],
    section: 5,
    min: 0,
    max: 0
  };
  private specificPagination = 0;

  @Watch("block.min", { deep: true })
  onSyncedMinChange() {
    this.block.list = [];
    for (let i = this.block.min; i <= this.block.max; i++) {
      this.block.list.push(i);
    }
  }

  @Watch("syncedTotal")
  onSyncedTotalChange() {
    this.handleMaxAndMin();

    this.specificPagination = this.syncedCurrent;
    this.block.list = [];
    for (let i = this.block.min; i <= this.block.max; i++) {
      this.block.list.push(i);
    }
  }

  public created() {
    this.handleMaxAndMin();

    this.specificPagination = this.syncedCurrent;
    for (let i = this.block.min; i <= this.block.max; i++) {
      this.block.list.push(i);
    }
  }

  private handleMaxAndMin() {
    if (this.syncedTotal === 0) {
      this.block.max = 0;
      this.block.min = 0;
    } else if (
      this.syncedTotal <=
      (this.block.section - 1) * this.syncedLimit
    ) {
      const max = Math.ceil(this.syncedTotal / this.syncedLimit);
      this.block.max = max;
      this.block.min = 1;
    } else {
      this.block.max = this.block.section;
      this.block.min = 1;
    }
  }

  private prev() {
    if (this.syncedCurrent > 1) {
      if (this.syncedCurrent === this.block.min) {
        if (this.block.min > 1) {
          this.block.min--;
          this.block.max--;
        }
      }
      this.$emit("prev");
    }
  }

  private next() {
    const max = Math.ceil(this.syncedTotal / this.syncedLimit);
    if (this.syncedCurrent < max) {
      if (this.syncedCurrent === this.block.max) {
        if (this.block.min < max) {
          this.block.min++;
          this.block.max++;
        }
      }
      this.$emit("next");
    }
  }

  private to(page: number) {
    this.$emit("to", page);

    const max = Math.ceil(this.syncedTotal / this.syncedLimit);
    if (this.specificPagination > max - this.block.section) {
      this.block.max = max;
      if (max - this.block.section > 0) {
        this.block.min = max - this.block.section + 1;
      } else {
        this.block.min = 1;
      }
    } else if (this.specificPagination < this.block.section) {
      this.block.min = 1;
      this.block.max = this.block.section;
    } else {
      const subSection = (this.block.section - (this.block.section % 2)) / 2;
      this.block.max = this.specificPagination + subSection;
      this.block.min = this.block.max - this.block.section + 1;
    }
  }

  private toSpecific() {
    this.$emit("toSpecific", this.specificPagination);

    const max = Math.ceil(this.syncedTotal / this.syncedLimit);
    if (this.specificPagination > max - this.block.section) {
      this.block.max = max;
      if (max - this.block.section > 0) {
        this.block.min = max - this.block.section + 1;
      } else {
        this.block.min = 1;
      }
    } else if (this.specificPagination < this.block.section) {
      this.block.min = 1;
      this.block.max = this.block.section;
    } else {
      const subSection = (this.block.section - (this.block.section % 2)) / 2;
      this.block.max = this.specificPagination + subSection;
      this.block.min = this.block.max - this.block.section + 1;
    }
  }

  private checkPaginationInput() {
    const max = Math.ceil(this.syncedTotal / this.syncedLimit);

    if (this.specificPagination) {
      if (isNaN(this.specificPagination)) {
        this.specificPagination = this.syncedCurrent;
      } else if (this.specificPagination > max) {
        this.specificPagination = max;
      } else if (this.specificPagination < 1) {
        this.specificPagination = 1;
      }
    }
  }
}
